class HomeBanner {
  constructor() {
    this.selectors = {
      container: '.banner-carousel > .owl-carousel',
      leftNav: '.banner-carousel__link--left',
      rightNav: '.banner-carousel__link--right',
      linkBackground: '.banner-carousel__links-background',
      linksContainer: '.banner-carousel__links',
      linkContainer: '.banner-carousel__link-container',
      linkNav: '.banner-carousel__link--nav',
    };
  }

  refresh() {
    const $container = $(this.selectors.container);

    $container.trigger('destroy.owl.carousel');
    this._removeCustomAddedElements();
  }

  owlOptions(onResized) {
    return {
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      items: 1,
      slideSpeed: 100,
      paginationSpeed: 400,
      dots: true,
      dotClass: this.selectors.linkContainer.replace('.', ''),
      loop: true,
      nav: true,
      responsiveRefreshRate: 100,
      dotsClass: this.selectors.linksContainer.replace('.', ''),
      responsive: {
        0: {
          dotsData: false,
          nav: false,
        },
        1260: {
          dotsData: true,
          nav: true,
        },
      },
      navText: [
        this._leftNavTextHtml(),
        this._rightNavTextHtml(),
      ],
      onInitialized: () => {
        this._onInitialized();
      },
      onResized,
    };
  }

  _onInitialized() {
    this._initializeBackground();
    this._initializeLeftRightNavigation();
  }

  _initializeBackground() {
    const $linksBackground =
      $('<div>', { class: this.selectors.linkBackground.replace('.', '') });

    $($linksBackground).insertBefore(this.selectors.linksContainer);
  }

  _initializeLeftRightNavigation() {
    const $container = $(this.selectors.container);

    $container.append($(this.selectors.leftNav).clone().show());
    $container.append($(this.selectors.rightNav).clone().show());

    $(`> ${this.selectors.leftNav}`, $container).on('click', () => {
      $container.trigger('prev.owl.carousel');
    });
    $(`> ${this.selectors.rightNav}`, $container).on('click', () => {
      $container.trigger('next.owl.carousel');
    });
  }

  _removeCustomAddedElements() {
    const $container = $(this.selectors.container);

    $(`> ${this.selectors.linkNav}`, $container).remove();
    $(`> ${this.selectors.linkBackground}`, $container).remove();
  }

  _rightNavTextHtml() {
    return `
      <span
        class="
          banner-carousel__link
          banner-carousel__link--nav
          banner-carousel__link--right"
      >
        <a class="fa fa-chevron-right"></a>
      </span>
    `;
  }

  _leftNavTextHtml() {
    return `
      <span
        class="
          banner-carousel__link
          banner-carousel__link--nav
          banner-carousel__link--left"
      >
        <a class="fa fa-chevron-left"></a>
      </span>
    `;
  }
}

export default HomeBanner;



// WEBPACK FOOTER //
// ./src/Carousel/HomeBanner.js